import { createRoot } from "react-dom/client";
import { InlineWidget } from "react-calendly";


const Page = ({ payload }) => {

	return (
		<div className="flex flex-col gap-5">
            <div className="text-center -mb-16">
                <h2 className="page-title pb-2">Let's Schedule a Demo</h2>
                <p>Pick a date and schedule time directly on both our calendars.</p>
            </div>

            <InlineWidget
                url="https://calendly.com/filerskeepers?hide_landing_page_details=1&hide_gdpr_banner=1"
                styles={{
                height: "700px",
                minWidth: "320px",
                }}
            />
        </div>
	)
}


function initPage(selector, payload) {
	createRoot(document.querySelector(selector)).render(
		<Page payload={payload} />
	);
}

export default initPage;
